import * as types from '@/store/types'
export default {
    getLoadedStatus: state => {
        return state.loaded
    },
    getMessages: state => {
        return state.messages
    },
    getMessagesWithNull: state => {
        let messages = state.messages.slice()
        messages.unshift({ id: null, title: 'Не выбрано' })
        return messages
    },
    messages: state => {
        return state.messages
    },
    messageModelDef: state => {
        return state.messageModelDef
    },
    getMessageById: state => id => {
        return state.messages.find(model => model.id === id)
    },
    messageLists: state => {
        return state.messageLists
    },
    getMessageListById: state => id => {
        return state.messageLists.find(model => model.id === id)
    },
    messageListModelDef: state => {
        return state.messageListModelDef
    },
    messageSortedInList: state => {
        return state.messageSortedInList
    },
    messagesLoaded: state => {
        return state.messagesLoaded
    },
    messageListsLoaded: state => {
        return state.messageListsLoaded
    },
    unsortedMessagesListId: state => {
        return state.unsortedMessagesListId
    },
    getCountHiddenMessagesLists: state => {
        return state.messageLists.filter(model => model.visible === 0).length
    }
}
